export default __webpack_public_path__ + "static/media/mask.2de1230a.svg";